export const translations = {
    de: {
        nav: {
            home: 'Startseite',
            modules: 'Module',
            lessons: 'Lektionen',
            quizzes: 'Quiz',
            progress: 'Fortschritt',
            settings: 'Einstellungen',
        },
        modules: {
            title: 'Module',
            lessons: 'Lektionen',
            exercises: 'Übungen',
            duration: 'Dauer',
            points: 'Punkte',
            noModules: 'Keine Module verfügbar',
            class: 'Klasse',
            semester: 'Semester',
            selectModule: 'Wähle ein Modul',
            selectModuleDesktop: 'Wähle ein Modul aus der Seitenleiste',
            selectModuleMobile: 'Wähle ein Modul aus dem Dropdown-Menü',
            loadError: 'Fehler beim Laden der Module',
            backToModule: 'Zurück zum Modul',
            lessonsInModule: 'Lektionen in diesem Modul',
            lessonSingular: 'Lektion',
            lessonPlural: 'Lektionen',
            moduleLoading: 'Modul wird geladen…',
            moduleLoadError: 'Modul konnte nicht geladen werden.',
            unknownError: 'Unbekannter Fehler beim Laden des Moduls.',
            tryAgainLater: 'Bitte versuche es später erneut oder kontaktiere den Admin.',
            backToLessons: 'Zurück zu den Lektionen',
            completeAndNext: 'Nächste Lektion',
            completeLesson: 'Lektion abgeschlossen',
            finishModule: 'Modul abschließen',
            lessonOf: 'Lektion {{current}} von {{total}}',
            back: 'Zurück',
            congratulations: '🎉 Herzlichen Glückwunsch! 🎉',
            moduleCompleted: 'Modul abgeschlossen!',
            moduleCompletedText: 'Du hast das Modul <strong>{{title}}</strong> erfolgreich abgeschlossen.',
            lessonsCompleted: 'Lektionen',
            quizzesAvailable: 'Quiz verfügbar',
            quizzesForModule: 'Quiz zu diesem Modul:',
            backToModule: 'Zurück zum Modul',
            goToDashboard: 'Zum Dashboard',
            startQuiz: 'Quiz starten',
        },
        quizzes: {
            title: 'Quiz & Tests',
            subtitle: 'Teste dein Wissen mit interaktiven Quiz zu den Modulen. Sammle Punkte und verfolge deinen Fortschritt!',
            activeModule: 'Aktives Modul',
            completed: 'Quiz absolviert',
            average: 'Durchschnitt',
            pointsEarned: 'Punkte verdient',
            bestPerformance: 'Beste Leistung',
            all: 'Alle',
            practice: 'Übung',
            searchQuiz: 'Quiz suchen...',
            allCategories: 'Alle Kategorien',
            questions: 'Fragen',
            timeLimit: 'Zeitlimit',
            startQuiz: 'Quiz starten',
            minutes: 'min',
            tries: 'Versuche:',
            bestpoints: 'Beste Punktzahl:',
            retry: "Erneut versuchen",
        },
        lessons: {
            title: 'Lektionen',
            start: 'Starten',
            continue: 'Fortsetzen',
            completed: 'Abgeschlossen',
            locked: 'Gesperrt',
            learninggoals: 'Lernziele:',
            theory: 'Theorie',
            lesson: 'Lektion',
            of: 'von',
        },
        quiz: {
            title: 'Quiz',
            loading: 'Quiz wird geladen…',
            error_loading: 'Quiz konnte nicht geladen werden.',
            completed: 'Geschafft!',
            of: 'von',
            questions_correct: 'Fragen richtig',
            points: 'Punkte',
            correct: 'Richtig!',
            incorrect: 'Leider falsch.',
            back_to_overview: 'Zurück zur Übersicht',
            already_completed_title: 'Dieses Quiz hast du bereits absolviert.',
            already_completed_text: 'Du kannst das Quiz nicht erneut starten.',
            start_description: 'Quiz zum Modul „{{module}}". Dieses Quiz kann nur einmal absolviert werden.',
            questions: 'Fragen',
            time_limit: 'Zeitlimit',
            average_points: 'Durchschnittliche Punkte',
            start_button: 'Quiz starten',
            your_answer: 'Deine Antwort',
            in_unit: 'in {{unit}}',
            enter_answer: 'Antwort eingeben',
            choose: '-- Wählen --',
            question_of: 'Frage {{current}} von {{total}}',
            question: 'Frage',
            ai_loading: 'KI-Erklärung wird geladen...',
            ai_explanation: 'KI-Erklärung:',
            no_explanation: 'Keine Erklärung verfügbar.',
            explanation_error: 'Fehler beim Abrufen der Erklärung.',
            solution: 'Lösung:',
            check_answer: 'Antwort prüfen',
            next_question: 'Nächste Frage',
            finish_quiz: 'Quiz beenden',
            ai_system_prompt: 'Du bist ein hilfreicher Tutor für Rechnungswesen in Österreich.\nEin Student hat eine Frage beantwortet und die Antwort war falsch.\nErkläre kurz und verständlich, warum die Antwort falsch ist und was die korrekte Antwort ist.\nNutze Markdown für bessere Lesbarkeit (fett, kursiv, Listen, Code wenn nötig).',
            start: 'Quiz starten',
            submit: 'Absenden',
            next: 'Nächste Frage',
            previous: 'Vorherige Frage',
            score: 'Punkte',
            total_questions: "Anzahl Fragen",
            partial: "Teilweise Richtig!",
        },
        dashboard: {
            readyForLesson: 'Bereit für eine weitere Lerneinheit?',
            yourLessons: 'Deine Lektionen',
            viewAll: 'Alle anzeigen',
            inProgress: 'In Bearbeitung',
            notStarted: 'Nicht begonnen',
            repeat: 'Wiederholen',
            noLessons: 'Noch keine Lektionen',
            startFirstLesson: 'Starte deine erste Lektion und beginne deine Lernreise!',
            discoverLessons: 'Lektionen entdecken',
            openQuizzes: 'Offene Quiz',
            allQuizzes: 'Alle Quiz',
            allQuizzesDone: 'Alle Quiz erledigt!',
            noOpenQuizzes: 'Super, du hast derzeit keine offenen Quiz.',
            open: 'Offen',
            quizForLesson: 'Quiz zur Lektion',
            recentQuizResults: 'Letzte Quiz-Ergebnisse',
            correct: 'richtig',
            noQuizCompleted: 'Noch keine Quiz absolviert',
            testKnowledge: 'Teste dein Wissen und sammle Punkte!',
            daysStreak: 'Tage Streak',
        },
        common: {
            loading: 'Lädt...',
            error: 'Fehler',
            save: 'Speichern',
            cancel: 'Abbrechen',
            close: 'Schließen',
            back: 'Zurück',
            continue: 'Weiter',
            edit: 'Bearbeiten',
            delete: 'Löschen',
            confirm: 'Bestätigen',
            welcomeBack: 'Willkommen zurück',
            noSelection: 'keine Auswahl',
            part: 'Teil',
            unit: 'Einheit',
        },
        aiChat: {
            title: 'fintogo Lerncoach',
            messagePlaceholder: 'Schreibe deine Nachricht...',
            questionPlaceholder: 'Frage stellen...',
            noAnswer: 'Keine Antwort erhalten.',
            error: 'Fehler beim Abrufen der Antwort.',
        },
        auth: {
            login: 'Anmelden',
            logout: 'Abmelden',
            register: 'Registrieren',
            email: 'E-Mail',
            password: 'Passwort',
            forgotPassword: 'Passwort vergessen?',
        },
        teacher: {
            dashboard: 'Lehrer Dashboard',
            class: 'Klasse:',
            school: 'Schule:',
            noClassAssigned: 'Keine Klasse zugewiesen',
            noSchool: 'Keine Schule',
            quizzesCompleted: 'Quiz absolviert',
            averagePerformance: 'Klassen Durschnitt',
            pointsCollected: 'Klassen Gesamtpunkte',
            bestPerformance: 'Beste Leistung',
            studentsInClass: 'Schüler in Ihrer Klasse',
            noStudentsFound: 'Keine Schüler gefunden',
            noStudentsInClass: 'In der Klasse "{className" sind noch keine Schüler registriert.',
            noClassAssignedText: 'Sie haben keine Klasse zugewiesen bekommen.',
            rank: '#',
            name: 'Name',
            points: 'Punkte',
            level: 'Level',
            quizzesDone: 'Quiz absolviert',
            average: 'Durchschnitt',
            loadingDashboard: 'Dashboard wird geladen...',
            noUserFound: 'Kein Benutzer gefunden',
            pleaseLogin: 'Bitte melden Sie sich an.',
            reload: 'Neu laden',
        }
    },
    en: {
        nav: {
            home: 'Home',
            modules: 'Modules',
            lessons: 'Lessons',
            quizzes: 'Quizzes',
            progress: 'Progress',
            settings: 'Settings',
        },
        modules: {
            title: 'Modules',
            lessons: 'Lessons',
            exercises: 'Exercises',
            duration: 'Duration',
            points: 'Points',
            noModules: 'No modules available',
            class: 'Class',
            semester: 'Semester',
            selectModule: 'Select a module',
            selectModuleDesktop: 'Select a module from the sidebar',
            selectModuleMobile: 'Select a module from the dropdown menu',
            loadError: 'Error loading modules',
            backToModule: 'Back to Module',
            lessonsInModule: 'Lessons in this Module',
            lessonSingular: 'Lesson',
            lessonPlural: 'Lessons',
            moduleLoading: 'Loading module…',
            moduleLoadError: 'Could not load module.',
            unknownError: 'Unknown error loading module.',
            tryAgainLater: 'Please try again later or contact the admin.',
            backToLessons: 'Back to Lessons',
            completeAndNext: 'Next Lesson',
            completeLesson: 'Lesson completed',
            finishModule: 'Finish Module',
            lessonOf: 'Lesson {{current}} of {{total}}',
            back: 'Back',
            congratulations: '🎉 Congratulations! 🎉',
            moduleCompleted: 'Module completed!',
            moduleCompletedText: 'You have successfully completed the module <strong>{{title}}</strong>.',
            lessonsCompleted: 'Lessons',
            quizzesAvailable: 'Quizzes available',
            quizzesForModule: 'Quizzes for this module:',
            backToModule: 'Back to Module',
            goToDashboard: 'Go to Dashboard',
            startQuiz: 'Start Quiz',
        },
        quizzes: {
            title: 'Quiz & Tests',
            subtitle: 'Test your knowledge with interactive quizzes on the modules. Collect points and track your progress!',
            activeModule: 'Active Module',
            completed: 'Quiz completed',
            average: 'Average',
            pointsEarned: 'Points earned',
            bestPerformance: 'Best performance',
            all: 'All',
            practice: 'Practice',
            searchQuiz: 'Search quiz...',
            allCategories: 'All Categories',
            questions: 'Questions',
            timeLimit: 'Time limit',
            startQuiz: 'Start Quiz',
            minutes: 'min',
            tries: 'Tries:',
            bestpoints: 'Most Points:',
            retryQuiz: "Retry Quiz",
        },
        lessons: {
            title: 'Lessons',
            start: 'Start lesson',
            continue: 'Continue',
            completed: 'Completed',
            locked: 'Locked',
            learninggoals: 'Learning goals:',
            theory: 'Theory',
            lesson: 'lesson',
            of: 'of',
        },
        quiz: {
            title: 'Quiz',
            loading: 'Loading quiz…',
            error_loading: 'Could not load quiz.',
            completed: 'Completed!',
            of: 'of',
            questions_correct: 'questions correct',
            points: 'Points',
            correct: 'Correct!',
            incorrect: 'Unfortunately incorrect.',
            back_to_overview: 'Back to overview',
            already_completed_title: 'You have already completed this quiz.',
            already_completed_text: 'You cannot start the quiz again.',
            start_description: 'Quiz for module "{{module}}". This quiz can only be completed once.',
            questions: 'Questions',
            time_limit: 'Time limit',
            average_points: 'Average points',
            start_button: 'Start quiz',
            your_answer: 'Your answer',
            in_unit: 'in {{unit}}',
            enter_answer: 'Enter answer',
            choose: '-- Choose --',
            question_of: 'Question {{current}} of {{total}}',
            question: 'Question',
            ai_loading: 'Loading AI explanation...',
            ai_explanation: 'AI Explanation:',
            no_explanation: 'No explanation available.',
            explanation_error: 'Error retrieving explanation.',
            solution: 'Solution:',
            check_answer: 'Check answer',
            next_question: 'Next question',
            finish_quiz: 'Finish quiz',
            ai_system_prompt: 'You are a helpful tutor for accounting in Austria.\nA student answered a question and the answer was incorrect.\nExplain briefly and clearly why the answer is wrong and what the correct answer is.\nUse Markdown for better readability (bold, italic, lists, code if necessary).',
            start: 'Start Quiz',
            submit: 'Submit',
            next: 'Next question',
            previous: 'Previous question',
            score: 'Score',
            total_questions: "Total Questions",
            partial: "Partially Right!",
        },
        dashboard: {
            readyForLesson: 'Ready for another learning session?',
            yourLessons: 'Your Lessons',
            viewAll: 'View all',
            inProgress: 'In Progress',
            notStarted: 'Not Started',
            repeat: 'Repeat',
            noLessons: 'No lessons yet',
            startFirstLesson: 'Start your first lesson and begin your learning journey!',
            discoverLessons: 'Discover Lessons',
            openQuizzes: 'Open Quizzes',
            allQuizzes: 'All Quizzes',
            allQuizzesDone: 'All quizzes completed!',
            noOpenQuizzes: 'Great, you currently have no open quizzes.',
            open: 'Open',
            quizForLesson: 'Quiz for lesson',
            recentQuizResults: 'Recent Quiz Results',
            correct: 'correct',
            noQuizCompleted: 'No quizzes completed yet',
            testKnowledge: 'Test your knowledge and collect points!',
            daysStreak: 'Days Streak',
        },
        common: {
            loading: 'Loading...',
            error: 'Error',
            save: 'Save',
            cancel: 'Cancel',
            close: 'Close',
            back: 'Back',
            continue: 'Continue',
            edit: 'Edit',
            delete: 'Delete',
            confirm: 'Confirm',
            welcomeBack: 'Welcome back',
            noSelection: 'no selection',
            part: 'Part',
            unit: 'Unit',
        },        aiChat: {
            title: 'fintogo learning coach',
            messagePlaceholder: 'Write your message...',
            questionPlaceholder: 'Ask a question...',
            noAnswer: 'No answer received.',
            error: 'Error retrieving answer.',
        },        auth: {
            login: 'Login',
            logout: 'Logout',
            register: 'Register',
            email: 'Email',
            password: 'Password',
            forgotPassword: 'Forgot Password?',
        },
        teacher: {
            dashboard: 'Teacher Dashboard',
            welcomeBack: 'Welcome back,',
            class: 'Class:',
            school: 'School:',
            noClassAssigned: 'No class assigned',
            noSchool: 'No school',
            
            // KPIs
            quizzesCompleted: 'Quizzes Completed',
            averagePerformance: 'Class Average',
            pointsCollected: 'Class Total Points',
            bestPerformance: 'Best Performance',
            
            // Student List
            studentsInClass: 'Students in Your Class',
            noStudentsFound: 'No Students Found',
            noStudentsInClass: 'There are no students registered in class "{className}" yet.',
            noClassAssignedText: 'You have not been assigned a class.',
            
            // Table Headers
            rank: '#',
            name: 'Name',
            points: 'Points',
            level: 'Level',
            quizzesDone: 'Quizzes Done',
            average: 'Average',
            
            // Error/Loading
            loadingDashboard: 'Loading dashboard...',
            noUserFound: 'No user found',
            pleaseLogin: 'Please log in.',
            reload: 'Reload',
        },
    }
};
